import ReloadButton from '../../../../features/ReloadButton/ReloadButton';

function PendingSubsPageHeader({ handleReload }) {
    return (
        <div className="flex justify-between items-center mb-6">
            <h2 className="font-medium text-xl">Pending Services</h2>

            <ReloadButton height="h-10" width="w-10" onClick={handleReload} />
        </div>
    );
}

export default PendingSubsPageHeader;
